module.exports = __webpack_public_path__ + "img/exclamation-circle-solid.2e0ec8ce.svg";